import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getAgents } from "redux/selectors/getAgents";
import ChannelConnectionsAdminService from "services/admin/channelConnections";
import { toast } from "react-toastify";

interface Props {
  open: boolean;
  onClose: () => void;
  onCreated: (channelConnectionID: number) => void;
}

const SOURCES = ["WHATSAPP", "TELEGRAM", "INSTAGRAM", "TEST_SANDBOX"] as const;

const CreateChannelDialog = ({ open, onClose, onCreated }: Props) => {
  const agents = ((useSelector(getAgents) as any[]) || []) as any[];
  const [agentID, setAgentID] = useState<number | "">("");
  const [source, setSource] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!source) {
      toast.error("Выберите тип канала");
      return;
    }
    try {
      setIsSubmitting(true);
      const payload: { source: string; agentID?: number } = { source };
      if (agentID) {
        payload.agentID = Number(agentID);
      }
      const { data: created } = await ChannelConnectionsAdminService.post(payload);
      toast.success("Канал создан");
      setAgentID("");
      setSource("");
      onCreated(created.id);
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Ошибка при создании канала");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Новый канал</DialogTitle>
      <DialogContent>
        <FormControl fullWidth className="mt-2 mb-4">
          <InputLabel id="agent-select-label">Агент (опционально)</InputLabel>
          <Select
            labelId="agent-select-label"
            label="Агент (опционально)"
            value={agentID}
            onChange={(e) => setAgentID(e.target.value as number | "")}
          >
            <MenuItem value="">
              <em>Без агента</em>
            </MenuItem>
            {agents.map((a: any) => (
              <MenuItem key={a.id} value={a.id}>
                {a.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="source-select-label">Тип канала</InputLabel>
          <Select
            labelId="source-select-label"
            label="Тип канала"
            value={source}
            onChange={(e) => setSource(e.target.value)}
          >
            {SOURCES.map((s) => (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>
          Отмена
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" disabled={isSubmitting}>
          Создать
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateChannelDialog;
